//@ts-check
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

let lastSectionIndex = 0;
const trigger = document.querySelector(".scroll-content-container");

if (trigger) {
  // Register GSAP plugins
  gsap.registerPlugin(ScrollTrigger);

  // Map animations to pinned content

  const scrollItems = trigger.querySelectorAll(
    ".scrollable-content > .content-container > *"
  );

  const pinnedItems = [];
  scrollItems.forEach((section) => {
    let item = false;
    //@ts-ignore
    if (section.dataset.target) {
      //@ts-ignore
      item = document.getElementById(section.dataset.target);
    }

    pinnedItems.push(item);
  });

  const scrollTrigger = ScrollTrigger.create({
    trigger: trigger,
    //markers: true,
    start: () => {
      const firstPinnedItem = pinnedItems[0];
      return `top 50%-=${firstPinnedItem.clientHeight / 2}px`;
    },
    end: () => {
      const lastPinnedItem = pinnedItems[pinnedItems.length - 1];
      return `bottom 50%+=${lastPinnedItem.clientHeight / 2}px`;
    },
    onUpdate: onUpdate,
    pin: ".pinned-content > .content-container",
    pinSpacing: false,
  });

  // Add listener to form ready refresh init
  if (window.boardflow) {
    // TODO: Improve and add listener only on forms that are inside this scroller
    window.boardflow.addEventListener("boardflow:marketo.forms.ready", () => {
      scrollTrigger.refresh();
      window.dispatchEvent(new Event("resize"));
    });
    window.boardflow.addEventListener(
      "boardflow:marketo.forms.did_layout",
      () => {
        scrollTrigger.refresh();
        window.dispatchEvent(new Event("resize"));
      }
    );
  } else {
    console.log("No boardflow integration");
  }
  // Handle the updated position

  function onUpdate() {
    const sectionIndex = getCurrentSectionIndex();

    pinnedItems.forEach((item, i) => {
      if (i !== sectionIndex) {
        gsap.isTweening(item) && gsap.killTweensOf(item);
        hide(item);
      }
    });

    if (sectionIndex !== lastSectionIndex) {
      if (lastSectionIndex !== -1) {
        // Get pinned content
        const item = pinnedItems[lastSectionIndex];
        if (item) hide(item);
      }

      if (sectionIndex !== -1) {
        // Get pinned content
        const item = pinnedItems[sectionIndex];
        if (item) show(item);
      }

      lastSectionIndex = sectionIndex;
    }
  }

  const item = pinnedItems[lastSectionIndex];
  if (item) show(item);

  // Find current section

  /*function getCurrentSection() {
    const currScroll = scrollY;

    let currentSection = -1;
    sections.forEach((section, i) => {
      if (currScroll > section.offsetTop - window.innerHeight / 2) {
        currentSection = section;
      }
    });
    return currentSection;
  }*/

  function getCurrentSectionIndex() {
    const currScroll = scrollY;
    let sectionIndex = -1;
    scrollItems.forEach((section, i) => {
      //@ts-expect-error
      if (currScroll > section.offsetTop - window.innerHeight / 2) {
        sectionIndex = i;
      }
    });
    return sectionIndex;
  }

  // Show-hide animations

  function show(target) {
    const duration = 0.35;
    gsap.fromTo(target, { autoAlpha: 0 }, { autoAlpha: 1, duration });
  }

  function hide(target) {
    const duration = 0.35;
    gsap.to(target, { autoAlpha: 0, duration: duration / 2 });
  }

  // Disable scroll trigger on mobile
  const media = window.matchMedia("screen and (max-width: 768px)");
  // Matches the element BoardflowUI initializes as a Marketo form
  const MARKETO_FORM_SELECTOR =
    '[data-init="marketo-form"], [data-render="marketo-form"]';
  ScrollTrigger.addEventListener("refreshInit", checkSTState);
  checkSTState();
  rewriteHiddenIDs();

  function checkSTState() {
    if (media.matches) {
      scrollTrigger.disable();
    } else if (
      scrollTrigger.pin?.children.length === 1 &&
      (scrollTrigger.pin.children[0]?.getBoundingClientRect().height ?? 0) >
        window.innerHeight
    ) {
      // Only if has one child disable if over viewport height
      scrollTrigger.disable();
      // Also set the only children to position relative to allow for auto spacing
      //@ts-expect-error Needs to be casted to HTMLElement
      scrollTrigger.pin.children[0].style.position = "relative";
    } else {
      //@ts-expect-error Needs to be casted to HTMLElement
      if (scrollTrigger.pin.children[0].style.position == "relative") {
        //@ts-expect-error Needs to be casted to HTMLElement
        scrollTrigger.pin.children[0].style.position == "";
      }
      scrollTrigger.enable();
    }

    rewriteHiddenIDs();
  }

  function rewriteHiddenIDs() {
    // Loop through items in the two columns,
    // Append _hidden to the ID as a workaround to allow linking

    const scrollHiddenItems = trigger?.querySelectorAll(
      ".scrollable-content > .content-container > * > .pinned-content-desktop"
    );

    if (media.matches) {
      // Mobile: the pinned column is hidden, so the copy duplicated into the
      // scrollable column is the one that keeps the original IDs
      pinnedItems.forEach((item) => _rewriteIDsWithin(item, _hideElementID));
      scrollHiddenItems?.forEach((item) =>
        _rewriteIDsWithin(item, _revertElementID)
      );
    } else {
      // Desktop: the pinned column is the visible one
      pinnedItems.forEach((item) => _rewriteIDsWithin(item, _revertElementID));
      scrollHiddenItems?.forEach((item) =>
        _rewriteIDsWithin(item, _hideElementID)
      );
    }
  }

  function _rewriteIDsWithin(root, rewrite) {
    // Every ID inside the hidden copy has to be rewritten, not only the ones on
    // its direct children: nested block IDs, such as the Vimeo player IDs or an
    // anchor deeper in the column, are duplicated as well and
    // document.getElementById() resolves them to the hidden copy because it
    // comes first in the DOM.
    if (!(root instanceof HTMLElement)) return;

    for (const el of root.querySelectorAll("[id]")) {
      // Marketo form internals are the exception. BoardflowUI finds its forms by
      // data attribute, then builds the form and its IDs at runtime and lets
      // forms2 resolve them with getElementById. Renaming those would make a
      // form that reloads later, on progressive profiling or a variant reset,
      // mount into the other copy, so the form subtree keeps the IDs the
      // library gave it.
      if (el.closest(MARKETO_FORM_SELECTOR)) continue;

      rewrite(el);
    }
  }

  function _hideElementID(el) {
    if (!el.dataset?.originalId) el.dataset.originalId = el.id;
    el.id = el.dataset.originalId + "_hidden";
  }

  function _revertElementID(el) {
    if (!el.dataset?.originalId) return;
    el.id = el.dataset.originalId;
  }
}
